exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".indicator{position:absolute;top:-10px;right:-10px;width:20px;height:20px;background-color:red;border:3px solid #fff;border-radius:50%;display:flex;justify-content:center;align-items:center}.noti_count{font-family:Montserrat,Lucida Sans Unicode,Lucida Grande,Lucida Sans,Arial,sans-serif;color:#f0f8ff;font-weight:700;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e817822","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Header.vue
// module id = 633
// module chunks = 0